export const THANK_YOU_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    desktop_bg_image: "",
    mobile_bg_image: "",
    gradient_angle: "254deg",
    gradient_start_color: "rgba(0, 0, 0, 0.00)",
    gradient_start_position: "-25.81%",
    gradient_end_color: "#0A3D5B",
    gradient_end_position: "78.26%",
    mobile_gradient_angle: "0deg",
    mobile_gradient_start_color: "rgba(5, 33, 50, 0.80)",
    mobile_gradient_start_position: "0%",
    mobile_gradient_end_color: "rgba(5, 33, 50, 0.80)",
    mobile_gradient_end_position: "100%",
    description: "",
    referral_description: "",
    influencer_description: "",
  },

  THANK_YOU_FIELDS_CONFIG: [
    {
      fieldName: "desktop_bg_image",
      label: "Desktop Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Mobile Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Background Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for background image",
      required: false,
      defaultValue: "Thank you page background",
    },
    {
      fieldName: "gradient_angle",
      label: "Gradient Angle",
      value: "254deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 254deg)",
      required: false,
      defaultValue: "254deg",
    },
    {
      fieldName: "gradient_start_color",
      label: "Gradient Start Color",
      value: "rgba(0, 0, 0, 0.00)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(0, 0, 0, 0.00)",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.00)",
    },
    {
      fieldName: "gradient_start_position",
      label: "Gradient Start Position",
      value: "-25.81%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient start position (e.g., -25.81%)",
      required: false,
      defaultValue: "-25.81%",
    },
    {
      fieldName: "gradient_end_color",
      label: "Gradient End Color",
      value: "#0A3D5B",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "#0A3D5B or rgba(10, 61, 91, 1)",
      required: false,
      defaultValue: "#0A3D5B",
    },
    {
      fieldName: "gradient_end_position",
      label: "Gradient End Position",
      value: "78.26%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient end position (e.g., 78.26%)",
      required: false,
      defaultValue: "78.26%",
    },
    {
      fieldName: "mobile_gradient_angle",
      label: "Mobile Gradient Angle",
      value: "0deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile gradient angle (e.g., 0deg)",
      required: false,
      defaultValue: "0deg",
    },
    {
      fieldName: "mobile_gradient_start_color",
      label: "Mobile Gradient Start Color",
      value: "rgba(5, 33, 50, 0.80)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(5, 33, 50, 0.80)",
      required: false,
      defaultValue: "rgba(5, 33, 50, 0.80)",
    },
    {
      fieldName: "mobile_gradient_start_position",
      label: "Mobile Gradient Start Position",
      value: "0%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile gradient start position (e.g., 0%)",
      required: false,
      defaultValue: "0%",
    },
    {
      fieldName: "mobile_gradient_end_color",
      label: "Mobile Gradient End Color",
      value: "rgba(5, 33, 50, 0.80)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(5, 33, 50, 0.80)",
      required: false,
      defaultValue: "rgba(5, 33, 50, 0.80)",
    },
    {
      fieldName: "mobile_gradient_end_position",
      label: "Mobile Gradient End Position",
      value: "100%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile gradient end position (e.g., 100%)",
      required: false,
      defaultValue: "100%",
    },
    {
      fieldName: "description",
      label: "Default Description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter default description (used when no specific source)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "referral_description",
      label: "Referral Form Description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter description for users from referral form",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "influencer_description",
      label: "Influencer Form Description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter description for users from influencer form",
      required: false,
      defaultValue: "",
    },
  ],

  METADATA_FIELDS: [],
};

